import { z } from 'zod'

const INN_PATTERN = /^\d{14}$/

/**
 * INN is required only for organizations with the "is_inn_required" permission enabled.
 * When the organization does not require it, the field stays optional and an empty
 * string is accepted, so the schema can be swapped reactively without resetting the form.
 *
 * The message is passed in by the caller, which pre-computes it outside of any computed
 * to avoid calling useI18n during a reactive re-evaluation.
 */
export const useInnValidationSchema = (isRequired: boolean, message: string) => {
  if (!isRequired) {
    return z.string().regex(INN_PATTERN, { message }).optional().or(z.literal(''))
  }

  return z
    .string({ required_error: message })
    .min(1, { message })
    .regex(INN_PATTERN, { message })
}
